import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./LegacyPDM.css";
import LegacyPDMOverview from "./LegacyPDMOverview";
import BannerImage from "../../../assets/other_image/ligacy.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const LegacyPDM = () => {
  return (
    <>
      <Helmet>
        <title>Legacy PDM to Teamcenter Migration Services in Pune | NexTech PLM</title>
        <meta
          name="description"
          content="Migrate your legacy PDM/PLM systems to Teamcenter with NexTech PLM. We offer secure, accurate, and end-to-end Legacy PDM migration services across India with data validation, cleanup, and seamless transition."
        />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
      </Helmet>

      <section className="LegacyPDM-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Legacy PDM-management" // Pass the heading text for this page
        />

        <div>
          <FloatingContactUs />
        </div>

        <LegacyPDMOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="legacy-page-heading">Unlock the Power :</h4>
            <h5 className="legacy-subheading">
              Discover the Transformative Benefits of Legacy PDM-management with NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>
                Best-in-class user experience with improved information visibility in the new
                system
              </li>
              <li>Single source of data and processes in Teamcenter</li>
              <li>Better extensibility to map various business requirements</li>
              <li>
                Tight Integration of various applications like project management, requirement &
                system engineering, manufacturing, and many more
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="legacy-page-heading">Teamcenter Solutions</h4>

                  <ul className="custom-bullets">
                    <li>Integration with NX </li>
                    <li>Integration with Catia</li>
                    <li>Integration with Creo</li>
                    <li>Integration with SolidWorks</li>
                    <li>Integration with Solid Edge </li>
                    <li>Integration with AutoCAD Vertical </li>
                  </ul>
                </div>

                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-manufacturing-data-process-management">
                          Manufacturing Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-community-collaboration">
                          Teamcenter Community Collaboration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cloud-implementation">
                          Teamcenter Implementation on Cloud
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-implementation">
                          Teamcenter Implementation
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="best-practices container">
            <h4 className="legacy-page-heading">Best Practices</h4>
            <ul className="custom-bullets">
              <li>
                Conducting a thorough assessment of existing systems and data to identify
                migration requirements and challenges.
              </li>
              <li>
                Developing a detailed migration plan tailored to the organization's specific needs
                and objectives.
              </li>
              <li>
                Utilizing automated tools and scripts to streamline data migration processes and
                minimize manual effort.
              </li>
              <li>
                Ensuring data integrity and consistency throughout the migration process through
                rigorous validation and testing.
              </li>
              <li>
                Providing comprehensive training and support to ensure a smooth transition and
                maximize user adoption of the new Teamcenter system.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="why-nextech container">
            <h4 className="legacy-page-heading">Why NexTech?</h4>
            <h5 className="legacy-subheading">
              For Legacy PDM/PLM to Teamcenter Migration
            </h5>
            <ul className="custom-bullets">
              <li>
                Expertise in conducting thorough assessments of existing systems and data to
                identify migration requirements and challenges.
              </li>
              <li>
                Tailored migration plans developed based on organization-specific needs and
                objectives.
              </li>
              <li>
                Utilization of automated tools and scripts to streamline data migration processes
                and minimize manual effort.
              </li>
              <li>
                Assurance of data integrity and consistency through rigorous validation and
                testing during the migration process.
              </li>
              <li>
                Comprehensive training and support provided to ensure a smooth transition and
                maximize user adoption of the new Teamcenter system.
              </li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  );
};

export default LegacyPDM;
